export const About = () => {
  return (
    <section id="about" className="section">
      <div className="section-head reveal">
        <div>
          <p className="section-eyebrow">02 — About</p>
          <h2 className="section-title">How I got here.</h2>
        </div>
      </div>
      <div className="about-prose reveal">
        <p>
          I started at Amazon on a warehouse floor in 2018 while studying
          computer science at community college. The gap between what I was
          learning and what I was doing wore on me, and after a knee injury
          on the job I worked up the nerve to ask how to move into
          something better. A senior operations lead heard me out and
          pointed me to resources most associates never knew we had.
        </p>
        <p>
          I applied for technical roles and was rejected more than once,
          cast a wider net, and landed in HR, where for the first time I
          was the person others came to with problems to solve. Once I had
          felt that, I could not go back. A manager who had come to trust
          my work recommended me into IT support. IT was closer to my goal
          but still not it. I had wanted to be a software engineer for
          years.
        </p>
        <p>
          When I found the Amazon Technical Academy, a full time
          engineering program, I went after it. My first attempt failed
          under the weight of working, studying, and preparing at once. I
          applied again at one of the hardest points in my life, determined
          to leave nothing behind whatever the outcome, and made it. I
          spent the next year training as an engineer before joining Prime
          Video.
        </p>
        <p className="about-prose-closer">
          I build the way I got here: persistently, and without assuming a
          door is closed until I have actually tried it.
        </p>
      </div>
    </section>
  );
};
